module.exports = __webpack_public_path__ + "static/img/top.955b3a31.png";